const wrapper = "zyowtfw1d7";
const header = "zyohr9509o";
const contextMenu = "zyocyohp2t";
const saveIndicatorPlaceholder = "zyosypu63i";
const saveIndicatorWrapper = "zyos1bygk1e";
const saveIndicator = "zyos8tj5gi";
const actionsWrapper = "zyoa1obegm9";
const elementToolbarPlaceholder = "zyoezt4js8";
const actions = "zyoa1xbmzrl";
const contentWrapper = "zyoc8kjyv4";
const retryButton = "zyorive6ql";

export { actions, actionsWrapper, contentWrapper, contextMenu, elementToolbarPlaceholder, header, retryButton, saveIndicator, saveIndicatorPlaceholder, saveIndicatorWrapper, wrapper };
import "./_component.style.linaria.module.css";
//# sourceMappingURL=_component.style.js.map
